import React from 'react';
import Icon from '../../../components/AppIcon';

const SafetyProtocolCard = ({ protocol, onExpand }) => {
  const getPriorityColor = (priority) => {
    return priority === 'high' ? 'bg-error/10 border-error' : 'bg-warning/10 border-warning';
  };

  return (
    <div className={`bg-white dark:bg-gray-800 ${getPriorityColor(protocol?.priority)} border-l-4 rounded-lg p-6 shadow-conservation`}>
      <div className="flex items-start gap-4">
        <div className="bg-primary/10 rounded-full p-3 flex-shrink-0">
          <Icon name={protocol?.icon} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">{protocol?.title}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">{protocol?.category}</p>
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
              protocol?.priority === 'high' ? 'bg-error text-error-foreground' : 'bg-warning text-warning-foreground'
            }`}>
              {protocol?.priority?.toUpperCase()} PRIORITY
            </span>
          </div>
          
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">{protocol?.description}</p>
          
          <div className="bg-background rounded-lg p-4 mb-4">
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Action Steps:</h4>
            <ol className="space-y-2">
              {protocol?.steps?.map((step, index) => (
                <li key={index} className="flex gap-3 text-sm text-gray-600 dark:text-gray-300">
                  <span className="flex-shrink-0 w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-xs font-medium">
                    {index + 1}
                  </span>
                  <span className="flex-1">{step}</span>
                </li>
              ))}
            </ol>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-error">
            <Icon name="Phone" size={16} />
            <span className="font-medium">{protocol?.emergencyContact}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyProtocolCard;